export const ProjectItems = [
    {
        id: 1,
        githubURL: "https://github.com/KyleMcSweeney3/zip-demo-site",
        title: "Ecommerce Demo Site",
        desc: "An Ecommerce demo site used to display the many flows of paying with Zip among other payment methods. Built as part of my role as Solution Engineer at Zip co.",
        techOne: "ReactJS",
        techTwo: "Commerce.js",
        techThree: "Node.js"
    },
    {
        id: 2,
        githubURL: "https://github.com/KyleMcSweeney3/pokemon-discord-bot",
        title: "Pokedex Discord Bot",
        desc: "The Pokedex discord bot utilises the PokeAPI to pull and display information about the many entities within the Pokemon universe.",
        techOne: "Discord.js",
        techTwo: "Node.js",
        techThree: "PokeAPI"
    },
    {
        id: 3,
        githubURL: "https://github.com/KyleMcSweeney3/PokemonLikeGame",
        externalURL: "https://pokemon-like-game.netlify.app/",
        title: "Pokemon Like 2D Game",
        desc: "This small game uses HTML, CSS, and Javascript to render the game.",
        techOne: "HTML Canvas",
        techTwo: "Javascript",
        techThree: "CSS"
    },
    {
        id: 4,
        githubURL: "https://github.com/KyleMcSweeney3/GlobalWeatherAPI",
        title: "Global Weather API",
        desc: "A small Mulesoft project to expose a SOAP web service through a REST API using RAML. Allowing for legacy SOAP services to be consumed as REST services.",
        techOne: "Mulesoft",
        techTwo: "Java",
        techThree: "SOAP & REST APIs"
    },
    {
        id: 5,
        githubURL: "https://github.com/KyleMcSweeney3/myPortfolio",
        title: "My Portfolio Website",
        desc: "Github Repo for my portfolio site, built using React and hosted via AWS.",
        techOne: "ReactJS",
        techTwo: "Node.js",
        techThree: "React Hooks"
    },
    {
        id: 6,
        githubURL: "https://github.com/KyleMcSweeney3/eCommerce-API",
        title: "eCommerce API",
        desc: "An API built to facilite payments for eCommerce software. Includes creation of a transaction, charging and refunding.",
        techOne: "Python",
        techTwo: "Flask",
        techThree: "SQLite"
    },
]